<template>
	<div id="crisisEventEscalationRecord">
		<div class="title">
			<b>危机事件上报</b>
			<a-button type="primary" @click="escalation">我要上报</a-button>
		</div>
		<div class="content">
			<b>上报记录</b>
			<div class="searchDiv">
				学生姓名：<a-input  placeholder="请输入" v-model="stuname" />
				<a-button type="primary" @click="search">查 询</a-button>
			</div>
			<div v-if="dataSource && dataSource.length">
				<a-table v-if="dataSource" :columns="columns" :dataSource="dataSource" :rowKey="row => row.EVENT_NUMBER" :pagination="{ pageSize: 10 }">
				</a-table>
			</div>
			<div v-else class="nodata">
				<img src="@/assets/kong.png" alt="">
				暂无数据
			</div>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
export default {
	name: 'CrisisEventEscalationRecord',
	data () {
		return {
			stuname: null,
			columns: [ // 确认信息
				{
					title: '危机事件编号',
					dataIndex: 'EVENT_NUMBER',
					key: 'EVENT_NUMBER',
					scopedSlots: { customRender: 'EVENT_NUMBER' }
				},
				{
					title: '学生姓名',
					dataIndex: 'REAL_NAME',
					key: 'REAL_NAME'
				},
				{
					title: '上报时间',
					dataIndex: 'C_TIME',
					key: 'C_TIME'
				},
				{
					title: '操作人',
					dataIndex: 'CONTACT_NAME',
					key: 'CONTACT_NAME',
				}
			],
			dataSource: null
		}
	},
	computed: {
		...mapState([
			'crisisRefer'
		])
	},
	methods: {
		...mapMutations([
			'setSpinning'
		]),
		...mapActions([
			'achieveCrisisRefer'
		]),
		async search () {
			if (this.stuname) {
				this.dataSource = this.crisisRefer.filter(item => item.REAL_NAME.indexOf(this.stuname) !== -1)
				console.log(this.dataSource)
			} else {
				this.dataSource = this.crisisRefer
			}
		},
		async escalation () {
			// 获取之前保存的信息
			await this.achieveCrisisRefer(3)
			this.$router.push('/dataCenter/crisisEventEscalationDetails')
		}
	},
	async mounted () {
		this.setSpinning(true)
		await this.achieveCrisisRefer(1)
		if (this.crisisRefer) {
			this.dataSource = this.crisisRefer
		}
		this.setSpinning(false)
	}
}
</script>

<style scoped>
#crisisEventEscalationRecord {
	width: 100%;
	background: #FFFFFF;
	border: 1px solid #E8E8E8;
	margin-bottom: 18px;
}
#crisisEventEscalationRecord .title {
	border-bottom: 1px solid #E8E8E8;
	padding: 16px 24px;
	box-sizing: border-box;
	color: #333333;
	font-weight: bold;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
#crisisEventEscalationRecord .content {
	padding: 16px 24px;
	box-sizing: border-box;
}
#crisisEventEscalationRecord .searchDiv {
	display: flex;
	align-items: center;
	margin-top: 20px;
	margin-bottom: 20px;
}
#crisisEventEscalationRecord .searchDiv .ant-input {
	width: 200px;
	margin-right: 15px;
}
#crisisEventEscalationRecord .nodata {
	display: flex;
	flex-direction: column;
	align-items: center;
	color: #CCCCCC;
	padding: 20px 0px;
}
#crisisEventEscalationRecord .nodata img {
	width: 80px;
	margin-bottom: 10px;
}
</style>
